export const categories = ['목', '화', '토', '금', '수']

/** 차트 좌우 여백 넣기위해 만든 카테고리 */
export const expandedCategories = ['', '목', '', '화', '', '토', '', '금', '', '수']

export const customLabels = ['목 木', '화 火', '토 土', '금 金', '수 水']

export const barColors = {
  목: 'rgba(var(--v-theme-fiveColor03), 1)',
  화: 'rgba(var(--v-theme-fiveColor01), 1)',
  토: 'rgba(var(--v-theme-fiveColor05), 1)',
  금: 'rgba(var(--v-theme-fiveColor04), 1)',
  수: 'rgba(var(--v-theme-fiveColor02), 1)',
}

/**
 * 차트별 컬러
 * 
 * 'bar', 'line', 'line' 순으로 작성
 * -> 막대 차트는 DOM 조작으로 색상을 변경하기 때문에 투명으로 설정
 */
export const chartColors = ['transparent', '#F47A49', '#3586FF']